export default __webpack_public_path__ + "static/media/attended.9f91cd71.svg";